module.exports = __webpack_public_path__ + "static/event-mentor-mentee-vol-2-23d56ab7bf66ffdd7f8ed6c9a9ac1b3b.jpg";